/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CnvFileDeploymentDiscoveryConfig = {
    type: CnvFileDeploymentDiscoveryConfig.type;
    /**
     *
     * Regular expression pattern to locate SeaBird CTD cast files (.cnv).
     *
     * Pattern should match paths to processed CTD cast files.
     * Example: "Vessel/Oceanographic/CTD/.*?/PROC/.*?\d+\.cnv"
     *
     */
    pattern: string;
};

export namespace CnvFileDeploymentDiscoveryConfig {

    export enum type {
        CNV_FILES = 'cnv_files',
    }


}

